/**
 * Shopify 购物车精密防护与体验优化脚本（终极加固版 - 堵死时差与快捷结账漏洞）
 */

const MAX_QTY = 5;
const RESTRICTED_VARIANT_ID = 47336004223125; // 核心包装变体 ID
let cartIntervalChecker = null;

// 用来缓存买家最近一次点击过的“移除”项的 Key
let recentlyRemovedKeys = new Set();

// 1. 定义需要隐藏的国家代码列表
const hiddenCountries = [
    'GE', 'AM', 'AZ',       // 格鲁吉亚、亚美尼亚、阿塞拜疆
    'KZ', 'UZ', 'TM', 'KG',  // 哈萨克斯坦、乌兹别克斯坦、土库曼斯坦、吉尔吉斯斯坦
    'RU', 'BY'               // 俄罗斯、白俄罗斯
];

// 2. 漏洞修复：初始化为 'LOADING' 锁定状态，防止接口未返回时被快速点击绕过
let currentCountryCode = 'LOADING';

// 3. 异步获取国家代码
async function initGeoIP() {
    try {
        const response = await fetch('https://akapi.angelkiss.cn/geoip/json/');
        const data = await response.json();
        currentCountryCode = data.country || "US"; // 拿到如 "US", "RU" 等，兜底 US
        
        console.log('【地理位置成功获取】当前国家:', currentCountryCode);
        // 获取成功后，主动触发一次更新，确保首屏状态正确
        enforceCartSafetyLock();
        updatePendantButtons();
    } catch (error) {
        console.error('获取地理位置失败，降级释放锁:', error);
        currentCountryCode = 'ERROR_BYPASS'; // 发生异常时防死锁降级
        enforceCartSafetyLock();
        updatePendantButtons();
    }
}

// 执行初始化获取国家
initGeoIP();

document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.querySelector('.cart_checkout-custom_button') || document.querySelector('button[name="checkout"]');
  const cartForm = document.querySelector('form[action="/cart"]');
  
  // ==========================================
  // 1. 结账按钮即刻拦截与强力放行跳转机制
  // ==========================================
  if (checkoutButton) {
    checkoutButton.addEventListener('click', function(event) {
      console.log('【用户点击结账】触发终极安全审计...');
      
      // 【加固逻辑】如果买家手速极快，在 GeoIP 还没返回时点击，强制拦截让其稍后重试
      if (currentCountryCode === 'LOADING') {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        alert("System is verifying your cart status, please wait a moment and click again.");
        return false;
      }

      const auditResult = checkBlockCondition();
      
      if (auditResult.shouldBlock) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        
        enforceCartSafetyLock(auditResult);
        
        alert(auditResult.warningMessage);
        if (typeof showPopUp === 'function') showPopUp(auditResult.warningMessage);
        return false;
      }
      
      event.preventDefault(); // 彻底切断可能导致页面卡死的有bug的主题JS
      
      if (window.fbq) fbq('track', 'InitiateCheckout', { content_type: 'product' });
      
      checkoutButton.disabled = true;
      checkoutButton.innerText = 'Loading...';

      try {
        if (cartForm) {
          cartForm.onsubmit = null; 
          
          const nativeSubmitBtn = document.createElement('button');
          nativeSubmitBtn.type = 'submit';
          nativeSubmitBtn.name = 'checkout';
          nativeSubmitBtn.style.display = 'none';
          cartForm.appendChild(nativeSubmitBtn);
          
          nativeSubmitBtn.click(); 
          nativeSubmitBtn.remove();
        } else {
          window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}checkout` : '/checkout';
        }
      } catch (err) {
        console.error('表单提交失败，启用URL路由兜底跳转:', err);
        window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}checkout` : '/checkout';
      }
      
    }, true); 
  }

  // ==========================================
  // 2. 全局代理数量改变/移除事件（捕获移除动作）
  // ==========================================
  document.addEventListener('click', function(event) {
    const target = event.target;
    
    const removeLink = target.closest('[data-remove-key]') || target.closest('.cart__items__remove a') || target.closest('.remove, [href*="step=1"]');
    const isQuantityAction = target.closest('.cart__items__quantity') || target.closest('[data-decrease-quantity]') || target.closest('[data-increase-quantity]') || target.closest('.quantity__button');

    if (removeLink) {
      const removeKey = removeLink.getAttribute('data-remove-key');
      if (removeKey) {
        console.log('【用户捕获】点击了移除商品，Key:', removeKey);
        recentlyRemovedKeys.add(removeKey); 
      }
      
      const row = removeLink.closest('[data-cart-item]') || removeLink.closest('.cart__items__row') || removeLink.closest('.cart__item');
      if (row) {
        row.style.opacity = '0.3';
        row.setAttribute('data-is-removing', 'true');
      }
    }

    if (removeLink || isQuantityAction) {
      const existingWarning = document.getElementById('packaging-warning');
      if (existingWarning) existingWarning.remove();

      if (cartIntervalChecker) clearInterval(cartIntervalChecker);
      cartIntervalChecker = null;

      // 稍微延时等待主题底层 DOM 数据变动或 Ajax 反应
      setTimeout(() => {
        enforceCartSafetyLock();
        updatePendantButtons();
        startSafetyInterval(); 
      }, 350);
    }
  });

  // ==========================================
  // 3. 购物车 5件 限额物理拦截
  // ==========================================
  const cartContainer = document.querySelector('.cart__items') || document.body;
  if (cartContainer) {
    cartContainer.addEventListener('click', function(e) {
      const plusBtn = e.target.closest('[data-increase-quantity]');
      if (!plusBtn) return;

      const wrapper = plusBtn.closest('[data-quantity-selector]') || plusBtn.parentElement;
      const input = wrapper?.querySelector('[data-quantity-input]') || wrapper?.querySelector('input[type="number"]');
      if (!input) return;

      const currentVal = parseInt(input.value) || 0;
      if (currentVal >= MAX_QTY) {
        e.preventDefault();
        e.stopImmediatePropagation(); 
        input.value = MAX_QTY;
        input.style.border = '1px solid red';
        setTimeout(() => { input.style.border = ''; }, 500);
      }
    }, true); 

    cartContainer.addEventListener('change', function(e) {
      const input = e.target.closest('[data-quantity-input]') || (e.target.tagName === 'INPUT' && e.target.type === 'number' ? e.target : null);
      if (!input) return;

      if (parseInt(input.value) > MAX_QTY) {
        input.value = MAX_QTY;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // 初始化首次页面环境评估与显隐控制
  enforceCartSafetyLock();
  updatePendantButtons();
  startSafetyInterval();
});

// ==========================================
// 4. 核心：四大限制条件纯同步审计函数
// ==========================================
function checkBlockCondition() {
  let mainProductCount = 0;      
  let hasRestrictedVariant = false;    
  let hasPackagingCollection = false;  
  let hasStraps = false;             
  let hasAccessory = false;          

  const data = window.CollectionsData || window.COLLECTIONS_DATA || { packaging: [], straps: [], accessory: [] };
  const cartLines = document.querySelectorAll('.cart__items__row, [data-cart-item], .cart__item');
  
  if (cartLines.length > 0) {
    cartLines.forEach(line => {
      if (line.offsetParent === null || line.getAttribute('data-is-removing') === 'true') return;

      const removeBtn = line.querySelector('[data-remove-key]');
      if (removeBtn) {
        const currentKey = removeBtn.getAttribute('data-remove-key');
        if (recentlyRemovedKeys.has(currentKey)) {
          return; 
        }
      }

      const href = line.querySelector('a[href*="/products/"]')?.getAttribute('href') || "";
      const handle = href.split('/products/')[1]?.split('?')[0]?.toLowerCase() || "";
      
      let variantId = 0;
      const qtyInput = line.querySelector('[data-quantity-input]') || line.querySelector('input[type="number"]');
      if (qtyInput) {
         variantId = parseInt(qtyInput.getAttribute('data-update-cart') || qtyInput.getAttribute('data-variant-id') || 0);
      }
      
      let quantity = qtyInput ? (parseInt(qtyInput.value) || 0) : 1;

      if (quantity > 0) {
        let isRestricted = false;

        if (variantId === RESTRICTED_VARIANT_ID) {
          hasRestrictedVariant = true;
          isRestricted = true;
        } else if ((Array.isArray(data.packaging) && data.packaging.includes(handle)) || handle === 'packaging' || handle.includes('box')) {
          hasPackagingCollection = true;
          isRestricted = true;
        } else if ((Array.isArray(data.straps) && data.straps.includes(handle)) || handle.includes('straps')) { 
          hasStraps = true; 
          isRestricted = true; 
        } else if ((Array.isArray(data.accessory) && data.accessory.includes(handle)) || handle.includes('accessory')) { 
          hasAccessory = true; 
          isRestricted = true; 
        }

        if (!isRestricted) { 
          mainProductCount += quantity; 
        }
      }
    });
  }

  const isPackagingInCart = (hasRestrictedVariant || hasPackagingCollection);
  const shouldBlock = (isPackagingInCart && mainProductCount === 0);
  
  let warningMessage = "Shopping Notice:\n";
  let reason = "";

  if (shouldBlock) {
    if (hasAccessory && hasStraps) {
      warningMessage += "Straps, Accessories and Packaging products are add-on items and cannot be purchased alone.";
      reason = "车内仅有包装 + 配件 + 肩带";
    } else if (hasAccessory) {
      warningMessage += "Accessories and Packaging products are add-on items and cannot be purchased alone.";
      reason = "车内仅有包装 + 配件";
    } else if (hasStraps) {
      warningMessage += "Straps and Packaging products are add-on items and cannot be purchased alone.";
      reason = "车内仅有包装 + 肩带";
    } else {
      warningMessage += "Packaging products cannot be purchased separately.";
      reason = "单独购买了包装商品";
    }
    warningMessage += "\n\nPlease add a handbag to proceed with checkout.";
  }

  return { shouldBlock, warningMessage, reason, isPackagingInCart };
}

// ==========================================
// 5. 辅助：页面即时状态 UI 同步锁定器
// ==========================================
function enforceCartSafetyLock(preCalculatedAudit = null) {
  const auditResult = preCalculatedAudit || checkBlockCondition();
  const footer = document.querySelector('.template__cart__footer') || document.querySelector('.cart__footer') || document.querySelector('.cart__footer__checkout');
  const additionalButtons = document.querySelector('.cart_checkout-custom_button');
  
  // 【加固修复】抓取 Shopify 官方动态渲染的快捷结账容器
  const expressCheckoutContainer = document.getElementById('dynamic-express-checkout-container') || document.querySelector('.additional-checkout-buttons');

  if (auditResult.shouldBlock) {
    if (footer && !document.getElementById('packaging-warning')) {
      const warningDiv = document.createElement('div');
      warningDiv.id = 'packaging-warning';
      warningDiv.style.cssText = "padding:15px; border:2px dashed #d9534f; background:#fff5f5; color:#d9534f; text-align:center; border-radius:8px; margin-bottom:15px; font-size:14px; font-weight:bold; width:100%; clear:both; box-sizing:border-box;";
      warningDiv.innerHTML = `<p style="margin:0;">Shopping Notice:</p><p style="margin:4px 0 0; font-weight:normal;">${auditResult.warningMessage}</p>`;
      footer.insertBefore(warningDiv, footer.firstChild);
    }
    
    // 隐藏自定义结账按钮
    if (additionalButtons) {
      additionalButtons.style.display = "none";
    }
    
    // 【加固逻辑】如果触发拦截，必须强行让快捷结账（PayPal等）彻底隐藏并失效，不允许绕过
    if (expressCheckoutContainer) {
      expressCheckoutContainer.style.setProperty('display', 'none', 'important');
      expressCheckoutContainer.style.pointerEvents = "none";
    }
  } else {
    const warningBox = document.getElementById('packaging-warning');
    if (warningBox) warningBox.remove();
    
    if (additionalButtons) {
      additionalButtons.style.pointerEvents = "auto";
      additionalButtons.style.display = "block";
    }
    
    // 【加固逻辑】条件允许时恢复快捷结账显示
    if (expressCheckoutContainer) {
      expressCheckoutContainer.style.setProperty('display', 'block', 'important');
      expressCheckoutContainer.style.pointerEvents = "auto";
    }
  }
}

// ==========================================
// 6. 核心优化：下部推荐入口加购按钮动态显隐控制
// ==========================================
function updatePendantButtons() {
  const currentPendantBtns = document.querySelectorAll('.pendant-select-btn');
  if (currentPendantBtns.length === 0) return;

  const audit = checkBlockCondition();
  
  // 【加固逻辑】如果还在 loading 状态，默认先当做黑名单处理以求安全
  const isBlacklistCountry = currentCountryCode === 'LOADING' ? true : hiddenCountries.includes(currentCountryCode);
  
  currentPendantBtns.forEach(btn => {
    const btnHref = btn.getAttribute('href') || "";
    const boxContainer = btn.closest('.pendant-select-btn-box');
    if (!boxContainer) return;
    
    if (btnHref.includes('/products/packaging')) {
      if (isBlacklistCountry || audit.isPackagingInCart) {
        boxContainer.style.setProperty('display', 'none', 'important');
      } else {
        boxContainer.style.setProperty('display', 'block', 'important'); //
      }
    }
  });
}

// 10秒自毁智能轮询器
function startSafetyInterval() {
  let executionCount = 0;
  if (cartIntervalChecker) clearInterval(cartIntervalChecker);
  cartIntervalChecker = setInterval(() => {
    executionCount++;
    enforceCartSafetyLock();
    updatePendantButtons(); 
    if (executionCount >= 10) {
      clearInterval(cartIntervalChecker);
      cartIntervalChecker = null;
    }
  }, 1000);
}

// 深度 MutationObserver DOM 监听
const cartFormElement = document.querySelector('form[action="/cart"]') || document.body;
if (cartFormElement) {
  const cartObserver = new MutationObserver((mutations) => {
    let shouldTrigger = false;
    mutations.forEach(mut => {
      if (mut.type === 'childList' && mut.target.id !== 'packaging-warning') {
        shouldTrigger = true;
      }
    });
    if (shouldTrigger) {
      enforceCartSafetyLock();
      updatePendantButtons();
    }
  });
  cartObserver.observe(cartFormElement, { childList: true, subtree: true });
}